import { Divider, Stack, Typography } from '@mui/material';
import { useIdPs } from 'api/idps';
import IdPMethodCard from 'components/IdPsGallery/IdPMethodCard';
import IdpGallery from 'components/IdPsGallery/IdPsGallery';
import SearchInput from 'components/shared/SearchInput';
import { GENERIC_IDP_ID, Method } from 'consts';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import React, { useMemo, useState } from 'react';
import { useStepNavigate } from 'utils/navigation';

const SelectIdPPage: React.FC = () => {
	const { data: idps } = useIdPs();
	const [idpSearch, setIdpSearch] = useState('');
	const { navigateToStep } = useStepNavigate();

	const navigateToFirstStep = (idpID: string, method: Method) => {
		navigateToStep(1, idpID, method);
	};

	const { idpID, method, isSubTenant } = useIdPConfigContext();

	const genericIdP = useMemo(
		() => idps?.data.find((idp) => idp.id === GENERIC_IDP_ID),
		[idps?.data]
	);

	const galleryIdPs = useMemo(
		() =>
			idps?.data.filter(
				(idp) => idp !== genericIdP && idp.methods.length > 0
			) || [],
		[idps?.data, genericIdP]
	);

	return (
		<Stack gap={4}>
			<Stack gap={0.5}>
				<Typography variant="h2">
					{intl.tr('ssoConfig.guide.selectIdP.pageTitle')}
				</Typography>
				<Typography>
					{intl.tr('ssoConfig.guide.selectIdP.pageSubheader')}
				</Typography>
			</Stack>
			<Stack gap={3}>
				<SearchInput
					data-testid="idps-gallery-search"
					sx={{ maxWidth: 528, height: 50 }}
					onSearchChange={setIdpSearch}
				/>
				<IdpGallery
					idps={galleryIdPs}
					loader={!idps?.data}
					filterText={idpSearch}
					selectedIdP={idpID}
					selectedMethod={method}
					disabled={isSubTenant}
					onMethodClick={navigateToFirstStep}
				/>
			</Stack>
			<Divider>{intl.tr('ssoConfig.guide.selectIdP.divider.or')}</Divider>
			<Stack gap={2}>
				<Typography>
					{intl.tr('ssoConfig.guide.selectIdP.custom.message')}
				</Typography>
				<Stack direction="row" gap={3}>
					{genericIdP &&
						genericIdP.methods.map((m) => (
							<IdPMethodCard
								idp={genericIdP}
								key={m}
								method={m}
								selectedIdP={idpID}
								disabled={isSubTenant}
								selectedMethod={method}
								onClick={() => {
									navigateToFirstStep(GENERIC_IDP_ID, m);
								}}
							/>
						))}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default SelectIdPPage;
